import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=8d59bcbe&lang=scss"

const __exports__ = script;

export default __exports__